import React from 'react';
import DV    from 'ts-data-validator';

import GalleryImage from '../GalleryImage';

function GallerySlide({
  fullSize,
  slide,
}) {
  return (
    <div>
      <GalleryImage
        size={fullSize ? 1920 : 1152}
        alt={slide.alt}
        src={slide.src}
        type={slide.type}
        url={slide.url}
      />
    </div>
  );
}

export default React.memo(GallerySlide);